import { useState, useEffect } from 'react';
import { Bot, RefreshCw, CheckCircle2, XCircle } from 'lucide-react';
import { useAuth } from '@/lib/AuthContext';
import { aiHealth } from '@/lib/api';

export const AiHealthCard = () => {
  const { token } = useAuth();
  const [health, setHealth] = useState(null);
  const [checking, setChecking] = useState(false);

  const check = async () => {
    setChecking(true);
    try {
      const res = await aiHealth(token);
      setHealth(res.data);
    } catch (err) {
      setHealth({ status: 'error', message: err.response?.data?.detail || 'Health-Check fehlgeschlagen' });
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => { check(); }, []);

  const ok = health?.status === 'ok';

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 flex items-center justify-between" data-testid="ai-health-card">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${health === null ? 'bg-slate-100 text-slate-400' : ok ? 'bg-teal-50 text-teal-600' : 'bg-red-50 text-red-500'}`}>
          <Bot className="w-5 h-5" />
        </div>
        <div>
          <div className="text-xs text-slate-500">KI-Dienst</div>
          <div className="flex items-center gap-1.5 font-semibold text-sm" data-testid="ai-health-status">
            {health === null ? (
              <span className="text-slate-400">Prüfe…</span>
            ) : ok ? (
              <><CheckCircle2 className="w-4 h-4 text-teal-600" /><span className="text-slate-900">Verbunden</span></>
            ) : (
              <><XCircle className="w-4 h-4 text-red-500" /><span className="text-red-600">{health.message}</span></>
            )}
          </div>
        </div>
      </div>
      <button
        onClick={check}
        disabled={checking}
        className="text-slate-400 hover:text-teal-600 transition-colors p-2"
        data-testid="ai-health-refresh-button"
        title="Erneut prüfen"
      >
        <RefreshCw className={`w-4 h-4 ${checking ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
};

export default AiHealthCard;
